import { render, staticRenderFns } from "./BannerVideoGloboSection.vue?vue&type=template&id=038f6ba4"
import script from "./BannerVideoGloboSection.vue?vue&type=script&lang=ts"
export * from "./BannerVideoGloboSection.vue?vue&type=script&lang=ts"
import style0 from "./BannerVideoGloboSection.vue?vue&type=style&index=0&id=038f6ba4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports